import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';

export interface AppUpdateSnackbarData {
  kind: 'update' | 'offline';
  message: string;
  actionLabel: string;
  action: 'reload' | 'dismiss';
}

@Component({
  selector: 'gd-app-update-snackbar',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './app-update-snackbar.component.html',
  styleUrls: ['./app-update-snackbar.component.scss'],
})
export class AppUpdateSnackbarComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public readonly data: AppUpdateSnackbarData,
    private readonly snackBarRef: MatSnackBarRef<AppUpdateSnackbarComponent>,
    @Inject(DOCUMENT) private readonly document: Document,
  ) {}

  onAction(): void {
    this.snackBarRef.dismissWithAction();
    if (this.data.action === 'reload') this.document.location.reload();
  }
}
